import React from "react";

export default function AmexIcon() {
  return (
    <svg
      width="46"
      height="22"
      viewBox="0 0 46 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="46" height="22" fill="#1F72CD" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7243 8L7 14.991H11.4585L12.0113 13.8764H13.2747L13.8274 14.991H18.735V14.1403L19.1723 14.991H21.7109L22.1482 14.1223V14.991H32.3546L33.5957 13.9053L34.7577 14.991L40 15L36.2639 11.515L40 8H34.8391L33.631 9.06565L32.5055 8H21.4022L20.4488 9.80444L19.4729 8H15.0237V8.82179L14.5288 8H10.7243ZM26 9H31.7071L33.4527 10.6381L35.2545 9H37L34.3478 11.5145L37 14H35.1753L33.4297 12.3429L31.6188 14H26V9ZM27 10.9363V10.0009V10H30.4811L32 11.4959L30.4138 13H27V11.9788H30.0435V10.9363H27ZM11.6665 9H13.8853L16.4074 13.725V9H18.8381L20.7861 12.3878L22.5815 9H25V14H23.5284L23.5164 10.082L21.3709 14H20.0545L17.897 10.082V14H14.8696L14.2956 12.8791H11.1948L10.6221 13.999H9L11.6665 9ZM12 12L13.0006 10L14 12H12Z"
        fill="white"
      />
    </svg>
  );
}
